import { render, staticRenderFns } from "./center-top.vue?vue&type=template&id=66389bc8&scoped=true&"
import script from "./center-top.vue?vue&type=script&lang=js&"
export * from "./center-top.vue?vue&type=script&lang=js&"
import style0 from "./center-top.vue?vue&type=style&index=0&lang=less&"
import style1 from "./center-top.vue?vue&type=style&index=1&lang=css&"
import style2 from "./center-top.vue?vue&type=style&index=2&id=66389bc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66389bc8",
  null
  
)

export default component.exports